/*
 * @Author: czj
 * @Date: 2025-04-17 15:33:00
 * @Description: 
 * @FilePath: \sxtracellular-single-cell - 作为基本项目模板备份\src\utils\request.js
 */
import axios from 'axios'
import { ElMessage } from 'element-plus';

import { getToken, getTicket } from '@/utils/auth'
import router from "@/router";
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 0 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['Authorization'] = 'Bearer ' + getToken();
    }

    if (getTicket()) {
      config.headers['ticket'] = getTicket();
    }

    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code == 202) {
      return res
    }
    if (res.code == 201) {
      return res
    }
    if (res.code && res.code !== 200 && res.code !== 10000) {
      if (res.code === 422) {
        if (typeof res.message === 'string') {
          ElMessage.error(res.message || 'Error');
        } else {
          let ps = res.message.map(item => {
            return `<p>${item}</p>`
          })
          let html = `<div>${ps}</div>`
          ElMessage.error(res.message && html || 'Error');
        }
      } else if (res.code === 401) {
        ElMessage.warning('License.认证已过期');
      }
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  error => {
    let tipMsg = ''
    if (window.location.hash == '#/index') {
      return ''
    }
    if (error.response) {
      let errRes = error.response;
      if (errRes.status === 500) {
        tipMsg = '500'
        // router.push({ name: 'Dashboard' });
        return;
      } else if (errRes.status === 429) {
        tipMsg = (errRes.data && errRes.data.message) ? errRes.data.message : '请勿频繁操作，请在1分钟后尝试操作！！'
      } else if (errRes.status === 401) {
        tipMsg = (errRes.data && errRes.data.message) ? errRes.data.message : '登录认证已过期，请刷新界面重新登录！！'//errRes.data && errRes.data.message ? errRes.data.message : '401'
      } else if (errRes.status === 404) {
        tipMsg = '非法请求！！'
        router.push({ name: 'Dashboard' });
      } else if (errRes.status === 422) {
        let errData = error.response.data
        if (Array.isArray(errData.message) && errData.message.length) {
          tipMsg = errData.message.join('；')
        } else {
          tipMsg = errData.message
        }
      } else if (errRes.status === 403) {
        tipMsg = errRes.data.message
      } else {
        tipMsg = errRes.status
      }
    } else {
      tipMsg = error.message || '网络错误'
    }
    ElMessage.error(tipMsg || '网络错误');
    return Promise.reject(error)
  }
)

export default service
